import {EVENTS} from 'common/domain/constants';

const MAX_DAYS = 23;
const MIN_DAYS = 0;

class BenefitDaysRequestSwitchController {
  constructor(EventEmitter, $rootScope) {
    'ngInject';
    this.EventEmitter = EventEmitter;
    this.rootScope = $rootScope;
    this.inEditMode = false;
    this.isDayModified = false;
  }

  $onInit() {
    this.days = this.cardData.enjoymentDays || 0;
    this.originalDayValue = this.days;
    this._onRefreshData();
  }

  _onRefreshData() {
    this.rootScope.$on(EVENTS.REFRESH_ON_FOOD_BENEFIT_MANAGER, (event, data) => {
      if (data.isReloaded) this.inEditMode = false;
    });
  }

  edit() {
    this.inEditMode = true;
  }

  notEdit() {
    if(this.isMobileApp) {
      this._setDefaultDaysValueWhenEmpty();
    }
  }

  _setDefaultDaysValueWhenEmpty() {
    if(isNaN(this.days) || this.dayPeriods === '' || !this.dayPeriods) this.dayPeriods = MIN_DAYS;
  }

  increaseOneDay() {
    this.days = this.days + 1;
    if (this.days > MAX_DAYS) this.days  = MAX_DAYS;
    const event = this.EventEmitter({days: this.days});
    this.changeDays(event);
  }

  decreaseOneDay() {
    if (this.days > MIN_DAYS) this.days = this.days - 1;
    const event = this.EventEmitter({days: this.days});
    this.changeDays(event);
  }

  onChangeValue() {
    this.sanitizeDayPeriods();
    this.days = this.dayPeriods;

    this.isDayModified = true;
    if (parseInt(this.days) === this.originalDayValue) {
      this.isDayModified = false;
    }

    const event = this.EventEmitter({days: parseInt(this.days)});

    this.changeDays(event);
  }

  sanitizeDayPeriods() {
    if(!this.isMobileApp) {
      this._setDefaultDaysValueWhenEmpty();
    }
    if (this.dayPeriods < MIN_DAYS) this.dayPeriods = MIN_DAYS;
    if (this.dayPeriods > MAX_DAYS) this.dayPeriods = MAX_DAYS;
  }
}

export default BenefitDaysRequestSwitchController;


// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/benefitRequestList/benefitRequestCard/BenefitDaysRequestSwitch/benefitDaysRequestSwitch.controller.js